import { useQuery } from '@tanstack/react-query';

import { ApiFnReturnType } from '@/slw/shared/query-client';

import { getFeedbackTopics } from './contact-us.api';

type FeedbackTopicResponse = ApiFnReturnType<typeof getFeedbackTopics>;

export const useGetFeedbackTopics = () => {
  return useQuery<FeedbackTopicResponse>({
    queryKey: ['feedback-topics'],
    queryFn: () => getFeedbackTopics(),
  });
};
